// config/hub.ts - Endereço do hub da WiniEduca (D46; blueprint §9.2, 1.6).
//
// Login único, entrar, as seções da área logada e a ajuda ficam no hub. O endereço vem de
// VITE_HUB_CANONICAL_ORIGIN. Em desenvolvimento, o hub de produção é recusado, como o banco (D57):
// o login único local usa o hub local (http://localhost:5173) e os bancos clone.

const PRODUCAO = 'https://winieduca.com';

function normalizar(origem: string): string {
  return origem.trim().replace(/\/+$/, '');
}

/** Devolve a origem do hub. Lança erro com o motivo quando a configuração é recusada. */
export function resolverOrigemDoHub(isDevServer: boolean, raw: string | undefined): string {
  const origem = normalizar(raw ?? '');
  if (!origem) {
    if (isDevServer) throw new Error('Recusado: VITE_HUB_CANONICAL_ORIGIN não está configurado. Em desenvolvimento, use http://localhost:5173.');
    return PRODUCAO;
  }
  let url: URL;
  try {
    url = new URL(origem);
  } catch {
    throw new Error(`Recusado: VITE_HUB_CANONICAL_ORIGIN="${origem}" não é um endereço.`);
  }
  if (isDevServer && /(^|\.)winieduca\.com(\.br)?$/.test(url.hostname)) {
    throw new Error('Recusado: em desenvolvimento, o hub não pode ser o de produção (D57). Use http://localhost:5173.');
  }
  return url.origin;
}

export const HUB_ORIGIN = resolverOrigemDoHub(import.meta.env.DEV, import.meta.env.VITE_HUB_CANONICAL_ORIGIN);

/** Endereço completo de uma página do hub (ex.: `hubUrl('/inicio')`). */
export const hubUrl = (caminho: string): string => `${HUB_ORIGIN}${caminho}`;

/** Onde o hub troca a sessão pelo token do Firebase (login único). */
export const SSO_ME_URL = hubUrl('/api/account/sso/me');
